// extracted by mini-css-extract-plugin
export default {"fianceVideo":"responsiveStyles_fianceVideo__m0XOq","videoBox":"responsiveStyles_videoBox__5FcYb","videobg":"responsiveStyles_videobg__ivdu-"};